<script>
import dayjs from "dayjs";
import http from "../http";
import { mapGetters } from "vuex";
import FBarDate from "@/components/FBarDate";
import FTable from "@/components/FDataInterator";
import FChartPie from "@/components/FChartPie";

export default {
  name: "FPageSalesFuels",
  components: { FBarDate, FTable, FChartPie },

  data: () => ({
    fuels: null,
    total: null,
    updatedAt: null,
    selectedDate: Date.now(),
    type: null,
  }),

  mounted() {
    this.type = this.$route.query.as;

    this.getFuelsList(Date.now());
  },

  methods: {
    async getFuelsList(date) {
      const id = this.companySelected.id;
      const uri = `venda/combustiveis/${id}/${this.time_range(date)}`;

      try {
        const raw = (await http.get(uri, {
          clearCacheEntry:
            navigator.onLine && this.compareDates(Date.now(), date),
        })).data;

        const fuels = raw.data.map((f) => {
          const descricao = f.descricaoCombustivel;

          const valor = f.valorVendido.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: "currency",
            currency: "BRL",
          });

          const quantidade = f.quantidadeVendida.toLocaleString("pt-BR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          });

          return {
            title: descricao,
            fields: {
              valor,
              quantidade: quantidade + "L",
            },
            _fields: {
              valor: f.valorVendido,
              quantidade: f.quantidadeVendida,
            },
          };
        });

        if (this.compareDates(date, this.selectedDate)) {
          this.fuels = fuels;

          if (fuels && fuels.length > 0) {
            const sumTotal = fuels.reduce(
              (acc, cur) => [
                cur._fields.valor + acc[0],
                cur._fields.quantidade + acc[1],
              ],
              [0, 0]
            );

            this.total = [
              sumTotal[0].toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                style: "currency",
                currency: "BRL",
              }),
              sumTotal[1].toLocaleString("pt-BR", {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              }) + "L",
            ];
          }

          this.updatedAt =
            this.type === "day"
              ? dayjs(raw.lastSale)
                  .add(3, "hours")
                  .valueOf()
              : null;
        }
      } catch (e) {
        this.fuels = null;
        this.updatedAt = null;
        this.total = null;

        console.log(e);
      }
    },

    compareDates(ts1, ts2) {
      return (
        new Date(ts1).toLocaleDateString() ===
        new Date(ts2).toLocaleDateString()
      );
    },

    time_range(ts) {
      if (this.type === "month") {
        return `${dayjs(ts)
          .startOf("month")
          .toISOString()}/${dayjs(ts)
          .endOf("month")
          .toISOString()}`;
      }

      const _base = new Date(ts);

      const base = [_base.getFullYear(), _base.getMonth() + 1, _base.getDate()];

      const base_date = base
        .map((i) => i.toString().padStart(2, "0"))
        .join("-");

      return `${base_date}T00:00:00.000Z/${base_date}T23:59:59.000Z`;
    },

    handleDateChange(date) {
      this.selectedDate = date;

      this.getFuelsList(date);
    },
  },

  computed: {
    ...mapGetters(["companySelected"]),
  },
};
</script>

<template>
  <section class="fluid__desk_container">
    <FBarDate
      @change="this.handleDateChange"
      :lastUpdate="updatedAt"
      :type="this.type"
    />

    <section>
      <FChartPie
        :rawData="this.fuels"
        labelsKey="title"
        seriesKey="quantidade"
      />
      <FTable
        v-if="fuels"
        :items="fuels || []"
        :total="total"
        style="margin-top: 10px"
      />
    </section>
  </section>
</template>
